export default "__VITE_ASSET__Dd4stN1z__"